module.exports = __webpack_public_path__ + "img/aiStars.1e3d1038.svg";